import React from 'react';
import { FormikValues } from 'formik';
import DataForm from '../../components/DataForm';
import { FormHelpers } from '../../components/Form/Form';
import { api } from '../../hooks/api.hooks';
import { useAuthentication } from '../../state/Authentication';
import { updateUser } from '../../state/Authentication/actions';
import { useMessage } from '../../state/Message';
import { setMessage } from '../../state/Message/actions';
import { useDomainSchema } from './hooks';

interface DataDomainProps {
  schema: Api.Domain;
}

const DataDomain: React.FC<DataDomainProps> = ({ schema }) => {
  const { dispatch } = useAuthentication();
  const { dispatch: dispatchMessage } = useMessage();
  const { renderForm, data, humanReadableData, validationSchema } = useDomainSchema(schema);

  const handleSubmit = React.useCallback(
    async (values: any, { setFieldError }: FormHelpers) => {
      try {
        const { data: domain } = await api.patch<Api.UserDomain>(`/me/${schema.key}`, {
          attributes: values,
        });

        dispatch(updateUser({ domains: { [schema.key]: domain } }));
        dispatchMessage(setMessage('data.form.save.success', 'dataOverview'));
      } catch (e) {
        setFieldError('', 'error.server.unknown');
      }
    },
    [schema],
  );

  return (
    <DataForm
      onSubmit={handleSubmit}
      initialValues={data as FormikValues}
      data={humanReadableData}
      validationSchema={validationSchema}
    >
      {renderForm()}
    </DataForm>
  );
};

export default DataDomain;
